import FormGenerator from "components/customs/form-generator/input";
import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import { Plus, XCircle } from "react-feather";
import CustomSelect from "components/customs/dropdown";
import CommonModal from "components/common/modal";
import OthersForm from "components/forms/Others";
import { Toast, getFormattedContactNumber } from "utility/helpers";
import _ from "lodash";
import { officialSearch } from "services/services.official";
import { genericPost } from "services/services.general";
import {
  addProjectDropdownStyles,
  addProjectSearchInputStyle,
} from "constants/style";
import { FormLabel, RequiredIndicator } from "assets/js/Styles";
import styled from "styled-components";
import DropdownSearch from "components/customs/dropdownSearch";
import { POSITION_OPTIONS } from "./constants";
import { validateOthersForm } from "./utility";

const HouseMemberSection = styled(Row)`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

const HouseMemberColRight = styled.div`
  display: grid;
  grid-template-columns: 1fr 107px;

  @media screen and (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

const ModalHeader = styled.div`
  display: grid;
  justify-content: space-between;
  grid-auto-flow: column;
  margin-top: 0.5rem;
  margin-left: 0.7rem;
  margin-bottom: 1rem;
`;

const ModalContainer = styled.div`
  margin: 1rem;

  textarea {
    width: 100%;
    border: none;
    background: transparent;
  }
`;

const ModalCloseIconSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledXCircle = styled(XCircle)`
  cursor: pointer;
`;

const AddProjectSection = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 575.98px) {
    flex-direction: column-reverse;
  }
`;

const AddProjectButton = styled(Button)`
  padding: 0;
  justify-content: flex-end;
  width: 107px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 1rem !important;
  text-decoration: none;
  color: initial;
`;

const AddProjectButtonText = styled.span`
  margin-left: 0.5rem;
  margin-bottom: 0;
  font-style: italic;
`;

const Others = ({ onChange, allocationName, contact }) => {
  const [name, setName] = useState(null || allocationName);
  const [contactNumber, setContactNumber] = useState("" || contact);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isModalShown, setIsModalShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formFields, setFormFields] = useState({
    lastName: "",
    firstName: "",
    fullName: "",
    contact: "",
  });

  const toggleModal = () => setIsModalShown(!isModalShown);

  const handleOfficialSearch = _.debounce((inputValue, callback) => {
    officialSearch({
      position: selectedOption.label,
      inputValue,
      callback,
    });
  }, 1000);

  const sendData = (formData) => {
    setIsLoading(true);

    genericPost({
      url: "/official/create-others",
      formData,
      callback: ({ isSuccess, msg }) => {
        setIsLoading(false);

        if (isSuccess) {
          setIsModalShown(false);

          Toast({
            type: 1,
            content: "Successfully added directory.",
          });
        } else {
          Toast({
            type: 4,
            content: msg,
          });
        }
      },
    });
  };

  const handleOnSubmit = async () => {
    const isValid = await validateOthersForm(formFields);

    if (typeof isValid === "boolean") {
      const data = {
        fullName: `${formFields.firstName} ${formFields.lastName}`,
        firstName: formFields.firstName,
        lastName: formFields.lastName,
        contact: formFields.contact?.slice(1),
        position: "Others",
      };

      sendData(data);
    } else {
      Toast({
        type: 4,
        content: isValid,
      });
    }
  };

  useEffect(() => {
    if (contactNumber !== "0") {
      onChange({ allocationContactNumber: contactNumber });
    }
  }, [contactNumber]);

  useEffect(() => {
    setSelectedOption(POSITION_OPTIONS[0]);
    onChange({ officialPosition: POSITION_OPTIONS[0].value });
  }, []);

  return (
    <>
      <HouseMemberSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Position"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the recipient position"}</p>
        </Col>
        <Col
          xs="12"
          md="6"
        >
          <HouseMemberColRight>
            <CustomSelect
              onChange={(option) => {
                setSelectedOption(option);
                if (name) setName(null);
                if (contactNumber) setContactNumber("");
                onChange({ officialPosition: option.value });
              }}
              value={selectedOption}
              options={POSITION_OPTIONS}
              styles={addProjectDropdownStyles}
            />
          </HouseMemberColRight>
        </Col>
      </HouseMemberSection>

      <HouseMemberSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Recipient Contact"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the recipient contact"}</p>
        </Col>
        <Col
          xs="12"
          md="6"
        >
          <HouseMemberColRight>
            <AddProjectSection>
              <DropdownSearch
                placeholder="Official"
                onChange={(option) => {
                  setName(option);

                  onChange({
                    officialPosition: selectedOption.value,
                    allocationContactName: option.label,
                    officialId: option.value,
                  });

                  setContactNumber(getFormattedContactNumber(option.contact));
                }}
                loadOptions={handleOfficialSearch}
                styles={addProjectSearchInputStyle}
                value={name}
              />
              {selectedOption?.value === 6 && (
                <AddProjectButton
                  onClick={(e) => {
                    e.preventDefault();
                    setIsModalShown(true);
                  }}
                >
                  <Plus />
                  <AddProjectButtonText>{"Add Others"}</AddProjectButtonText>
                </AddProjectButton>
              )}
            </AddProjectSection>
          </HouseMemberColRight>
        </Col>
      </HouseMemberSection>

      <HouseMemberSection>
        <Col
          xs="12"
          md="6"
        >
          <FormLabel>
            {"Contact Number"}
            {RequiredIndicator}
          </FormLabel>
          <p>{"Provide the number of the recipient"}</p>
        </Col>
        <Col
          xs="12"
          md="6"
        >
          <HouseMemberColRight>
            <FormGenerator
              type="mobile"
              placeholder="Contact Number"
              value={contactNumber}
              isDisabled
            />
          </HouseMemberColRight>
        </Col>
      </HouseMemberSection>
      <CommonModal
        isOpen={isModalShown}
        handleClose={toggleModal}
        renderBody={
          <>
            <ModalCloseIconSection>
              <StyledXCircle
                onClick={() => {
                  toggleModal();
                  setIsModalShown(false);
                }}
              />
            </ModalCloseIconSection>
            <ModalContainer>
              <ModalHeader>
                <h3>{"Add Others"}</h3>
              </ModalHeader>
              <OthersForm
                handleOnSubmit={handleOnSubmit}
                formFields={formFields}
                setFormFields={setFormFields}
                isLoading={isLoading}
                isModal
                setIsModalShown={setIsModalShown}
              />
            </ModalContainer>
          </>
        }
        modalSize="lg"
      />
    </>
  );
};

export default Others;
